// buffer for paddings when calculating widths of elements
const BUFFER = 16;

// if not enough space to display all menu items, separate them depending on
// their priority value
const splitItemsByTheirPriority = (items, numberOfPriorityItems, isReduced) => {
  const highestPriorityNumber = items.reduce(
    (maximum, currentItem) => Math.max(maximum, currentItem.priority || 0),
    0,
  );

  const mainMenuWithUpdateCurrentItemPriority = items.map(menuItem => {
    const menuItemDuplicate = menuItem;

    if (isReduced && menuItem.url === window.location.href) {
      menuItemDuplicate.priority = highestPriorityNumber + 1;
    } else if (!isReduced && menuItemDuplicate.isActive) {
      menuItemDuplicate.priority = highestPriorityNumber + 1;
    }

    return menuItemDuplicate;
  });

  // sort menu array from highest to lowest priority value
  const sortedMenuArray = mainMenuWithUpdateCurrentItemPriority.sort(
    (currentItem, nextItem) => nextItem.priority - currentItem.priority,
  );

  let topPriorityArray = sortedMenuArray.slice(0, numberOfPriorityItems);
  let lowPriorityArray = sortedMenuArray.slice(numberOfPriorityItems);

  // keep only top priority items
  topPriorityArray = items.filter(({ title }) =>
    topPriorityArray.find(sortedItem => sortedItem.title === title),
  );

  // keep only low priority items
  lowPriorityArray = items.filter(({ title }) =>
    lowPriorityArray.find(restItem => restItem.title === title),
  );

  return [topPriorityArray, lowPriorityArray];
};

// get total width of all items as well as one of reduced variant to determine
// what can be displayed according to available space
const getItemTotalWidths = (
  mainMenu,
  logoRef,
  itemsRef,
  moreRef,
  isReduced,
) => {
  // starting with width of logo and security buffer of value 16
  let totalWidthFull = (logoRef.current?.clientWidth || 0) + BUFFER;
  let totalWidthReduced = (logoRef.current?.clientWidth || 0) + BUFFER;

  const [topPriorityArray] = splitItemsByTheirPriority(mainMenu, 2, isReduced);

  // add width of each item for totalWidthFull and width of those elements that
  // are top priority for totalWidthReduced
  itemsRef.current.forEach(item => {
    if (topPriorityArray.find(({ title }) => title === item?.innerText)) {
      totalWidthReduced += item?.clientWidth || 0;
    }

    totalWidthFull += item?.clientWidth || 0;
  });

  // add width of more menu item if reduced variant
  totalWidthReduced += moreRef.current?.clientWidth || 0;

  return [totalWidthFull, totalWidthReduced];
};

export { splitItemsByTheirPriority, getItemTotalWidths };
